import { Box, Stack, Typography } from "@mui/material";
import { UMargin, URow, USection } from "../common/ui.page";
import { CPage, CPageTitle, CPageTop, CSection } from "../components/cr.ui.page";
import { CUnitList, CMainField } from "../components/cr.ui.order";
import { UIcon } from "../common/ui.icon";
import { useOrder } from "../components/order";
import { ERROR_COLOR, GREY, WARN_COLOR, WHITE } from "../style/theme";
import { UButton } from "../common/ui.buttons";
import { Add } from "@mui/icons-material";
import { PageContext } from "../common/pages";
import { PageOrderMain } from "./p.order.main";
import { useContext } from "react";
import { PageUnitNew } from "./p.unit.new";
import { PageUnit } from "./p.unit";
import { Unit } from "../components/unit";
import { PageCrusade } from "./p.crusade";
import { Crusade } from "../components/crusade";
import { Report } from "../components/report";
import { PageReport } from "./p.report";


export function PageOrder(props) {
    const order = useOrder()
    const { path } = useContext(PageContext)

    if (order.requiredReports.length > 0) {
        return <Report match={order.requiredReports[0]}><PageReport /></Report>
    }

    if (path.length > 0) {
        if (path[0] == 'crusade') {
            return <Crusade><PageCrusade /></Crusade>
        }
    }

    if (path.length > 1) {
        if (path[0] == 'unit') {
            const unitId = path[1]
            if (unitId === 'new') {
                return <PageUnitNew />
            }
            return <Unit id={unitId}><PageUnit /></Unit>
        }
    }

    return <PageOrderMain />
}